export default __webpack_public_path__ + "static/media/all-trade.6baf8d9e.svg";